import * as React from "react";
import OverlayEditorView, { OverlayEditorViewProps } from "../../views/overlay-editor/overlay-editor-view";

const OverlayEditor: React.FunctionComponent<OverlayEditorViewProps> = props => {
    const { onChange, value, ...rest } = props;

    const [innerValue, setInnerValue] = React.useState(props.value);

    const onChangeHandle = React.useCallback(
        (newValue: string) => {
            setInnerValue(newValue);
            onChange(newValue);
        },
        [onChange]
    );

    return <OverlayEditorView {...rest} value={innerValue} onChange={onChangeHandle} />;
};

export default OverlayEditor;
